import React, { memo } from 'react';
import { string, func } from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';

import { withLabels } from 'containers/withLabels';
import { withErrorBoundary } from 'containers/ErrorBoundary';

import styles from './FieldNoResultsTooltip.module.scss';
const cx = classNames.bind(styles);

const FieldNoResultsTooltip = ({
  labels,
  className,
  title,
  description,
  handleLinkClick,
}) => (
  <div className={cx('tooltip', className)}>
    <h5 className={cx('title')}>{title}</h5>

    <div className={cx('description')}>
      <p>{description}</p>
      <p>
        {labels.noResultsLabelsSuffix}{' '}
        <Link
          to="/search#car"
          className={cx('button')}
          onClick={handleLinkClick}
        >
          {labels.noResultsLinksLabel}
        </Link>
      </p>
    </div>
  </div>
);

FieldNoResultsTooltip.propTypes = {
  className: string.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  handleLinkClick: func,
};

FieldNoResultsTooltip.defaultProps = {
  handleLinkClick: null,
};
export default memo(withLabels(withErrorBoundary(FieldNoResultsTooltip)));



// WEBPACK FOOTER //
// ./src/components/FieldNoResultsTooltip/FieldNoResultsTooltip.js